import { createRouter, createWebHistory } from "vue-router";

import { getEnv } from "@solvari/utils";

import routes from "./routes";

const router = createRouter({
  history: createWebHistory(getEnv().config.urlPrefix),
  routes,
});

export default router;
